<template>
  <div class="Willow">
    <ol>
      <li>
        <div>유일하게 밤을 이용하는 게임입니다</div>
        <div>게임 시작 전, 서버 설정을 변경하기 위해 재시작 합니다</div>
      </li>
      <li>밤이 되어 어두워지면 게임이 시작됩니다</li>
      <li>어둠 속에 오래 머물면 악몽 괴물이 공격합니다</li>
      <li>각자에게 지급된 10%의 라이터를 가지고 가장 오래 밤을 버텨야 합니다</li>
      <li>
        <div>맨손으로 다른 유저를 공격할 수 있습니다</div>
        <div>상대방에게 불을 붙일 수 있습니다</div>
      </li>
      <li>반딧불의 빛을 이용해서 악몽 괴물을 피할 수 있습니다</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Willow'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Willow.vue